import { lazy } from "react";
import { PATHS } from "@/lib/router";

const CallForHelpPage = lazy(() => import("./pages/CallForHelpPage"));

export const callForHelpRoutes = [
  {
    path: PATHS.CALL_FOR_HELP,
    element: <CallForHelpPage />,
  },
];
